import { ParticipationStatus } from '@slope/graphql/resolvers';
import { teeMs } from './teeMs';

export const compareScores = <
  T extends {
    status: ParticipationStatus;
    score?: number | null;
    teeTime?: string | null;
  },
>(
  a: T,
  b: T,
) => {
  const aNotWaiting = a.status !== ParticipationStatus.Waiting;
  const bNotWaiting = b.status !== ParticipationStatus.Waiting;

  if (aNotWaiting && bNotWaiting) {
    if (a.score === null || a.score === undefined) return 1;
    if (b.score === null || b.score === undefined) return -1;
    return a.score - b.score;
  }

  if (aNotWaiting) return -1;
  if (bNotWaiting) return 1;

  return a.teeTime && b.teeTime ? teeMs(a.teeTime) - teeMs(b.teeTime) : 0;
};
